
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.025 13.475c.3.3.3.75 0 1.05a.68.68 0 01-.525.225.68.68 0 01-.525-.225L9 10.55l-3.975 3.975a.68.68 0 01-.525.225.68.68 0 01-.525-.225c-.3-.3-.3-.75 0-1.05L7.95 9.5 3.975 5.525c-.3-.3-.3-.75 0-1.05.3-.3.75-.3 1.05 0L9 8.45l3.975-3.975c.3-.3.75-.3 1.05 0 .3.3.3.75 0 1.05L10.05 9.5l3.975 3.975z","fill":"#000"}}),_c('mask',{staticStyle:{"mask-type":"alpha"},attrs:{"id":"a","maskUnits":"userSpaceOnUse","x":"3","y":"4","width":"12","height":"11"}},[_c('path',{attrs:{"d":"M14.025 13.475c.3.3.3.75 0 1.05a.68.68 0 01-.525.225.68.68 0 01-.525-.225L9 10.55l-3.975 3.975a.68.68 0 01-.525.225.68.68 0 01-.525-.225c-.3-.3-.3-.75 0-1.05L7.95 9.5 3.975 5.525c-.3-.3-.3-.75 0-1.05.3-.3.75-.3 1.05 0L9 8.45l3.975-3.975c.3-.3.75-.3 1.05 0 .3.3.3.75 0 1.05L10.05 9.5l3.975 3.975z","fill":"#fff"}})]),_c('g',{attrs:{"mask":"url(#a)"}},[_c('path',{attrs:{"fill":"#5E5873","d":"M0 .5h18v18H0z"}})])])
          )
        }
      }
    